import React from "react";
import { render } from "react-dom";
import PropTypes from "prop-types";
import Tweezer from "tweezer.js";

const formContainer = document.querySelector("[data-search-form]");
const formHider = document.querySelector("[data-search-hider]");

const scrollToTop = () => {
    new Tweezer({
        start: window.scrollY,
        end: formContainer.getBoundingClientRect().top - 20 + window.scrollY,
        duration: 200
    })
        .on("tick", value => {
            window.scrollTo(0, value);
        })
        .begin();
};

const buttonClick = () => {
    formContainer.classList.toggle("is-visible");
    formContainer.classList.toggle("is-hidden");
    scrollToTop();
};

const initForm = form => {
    const title = form.querySelector("[data-form-title]").textContent;
    const container = document.querySelector("[data-switch-button]");

    render(<Button title={title} onButtonClick={buttonClick} />, container);
};

const Button = ({ title, onButtonClick }) => (
    <button
        className="button button--arrow button--search-form"
        onClick={onButtonClick}
        type="button"
    >
        {title}
    </button>
);

Button.propTypes = {
    title: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired
};

if (formContainer) initForm(formContainer);

if (formHider) {
    formHider.addEventListener("click", () => {
        buttonClick();
    });
}
